import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';

import './index.sass';

const { el } = bem('specialist');

const Address = ({ id, address, town, district, nickAddress, ...props }, index) => {
    return <div key={ index } className={ el('address') }>
        <div className={el('address-icon')}>
            <Icon name={'check-circle'} />
        </div>
        <div className={el('address-text')}>
            <Text>{[town !== '' ? `г. ${ town }` : '', district, nickAddress].filter(x => x).join(', ')}</Text>
        </div>
    </div>
};

export default Address;
